import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import WebIcon from '@mui/icons-material/Web';
import GridOnIcon from '@mui/icons-material/GridOn';
import GPAP_Button from "../../../../gpap-lib/Button_Collection";
import auth from '../../../service/Auth'
import AuthErrorDialog from "../components/AuthError";


const ExperimentSubmissionChoices =(props)=>{

    const [experimentSubmission, setExperimentSubmission] = useState(false);
    const [template, setTemplate] = useState(false);
    const [back, setBack] = useState(false);
    const [authError, setAuthError] = useState("");

    useEffect(() => {   
        if (auth.tokenExpired()){  
            setAuthError("Logging session timeout. Please log again");
        }
    });

    const goExperimentSubmission = (event) => {
        setExperimentSubmission(true);
    };

    const goExperimentTemplateSubmission = (event) => {
        setTemplate(true);
    };

    const goBack = (event) => {
        setBack(true);
    };

    /* OpenID session token error*/
    if (authError !== "" ) {
        return (
            <AuthErrorDialog errors={authError} open={true}/>
        );
    }

    /*Go to Experiment Submission */
    if (experimentSubmission) {
        return <Redirect to={{pathname:'/submitexperiments',owner:props.location.owner}}/>;
    }

    /*Go to experiment template submission*/
    if (template) {
        return  <Redirect to={{pathname:'/experimenttemplatesubmission', owner:props.location.owner}}/>;
    }

    /*Go back to group selection*/
    if(back) {
        return <Redirect to={{pathname:'/selectgroup'}}/>;
    }

    return (
        <div className={"mainContent"}>
            <Typography variant={"h5"} align={"center"}> Submit Experiments </Typography>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                <Card sx={{ m:2, minWidth: 275 }}>
                    <CardContent>
                        {/* Define manually choice*/}
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={8}>
                                <Typography variant="body">
                                    If you want to submit only a few experiments, you
                                    can enter data manually.
                                </Typography>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <GPAP_Button onClick={goExperimentSubmission}> 
                                    <WebIcon/> 
                                    Enter Data Manually 
                                </GPAP_Button>
                            </Grid>
                        </Grid>
                        {/* Define manually choice*/}
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={8}>
                                <Typography variant="body">
                                    For a batch upload, it is recommended to download a template. <br/>
                                    Fill in the records and upload it as TSV in the data submission page.
                                </Typography>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <GPAP_Button onClick={goExperimentTemplateSubmission}> 
                                    <GridOnIcon/> 
                                    Use Template 
                                </GPAP_Button>
                            </Grid>
                        </Grid>                        
                    </CardContent>
                    <CardActions>
                        <GPAP_Button onClick={goBack}> 
                            <i class="fa fa-arrow-circle-left" aria-hidden="true"></i> 
                                BACK TO OWNER SELECTION
                        </GPAP_Button>   
                    </CardActions>
                </Card>
            </Grid>                
        </div>
    );

}

export default ExperimentSubmissionChoices;
